import { memo } from "react";

import { ComplexCell } from "./ComplexCells";
import { StatusCell } from "./StatusCell";
import { BasicCell } from "./BasicCell";
import { useIsComplexCell } from "./hooks/useIsComplexCell";

import { useReportContext } from "@/components/Evaluate/report-context";
import { CellStatus } from "@/components/Evaluate/TableComponents/RowCell/Cells/primitives";
import { ColumnType, ReportCell, ReportColumn } from "@/types/evaluate";

interface CellProps {
  cell: ReportCell;
  column: ReportColumn;
}

export const Cell = memo<CellProps>(({ cell, column }) => {
  const { selectedColumn } = useReportContext();
  const isColumnSelected = selectedColumn?.id === column.id;
  const isComplexCell = useIsComplexCell(cell, column);

  if (column.id === -998) {
    return <div>_</div>;
  }

  if (
    (cell?.status === CellStatus.FAILED ||
      cell?.status === CellStatus.RUNNING ||
      cell?.status === CellStatus.QUEUED ||
      !cell) &&
    column.column_type !== ColumnType.HUMAN
  ) {
    return <StatusCell cell={cell} column={column} isColumnSelected={isColumnSelected} />;
  }

  if (isComplexCell) {
    return <ComplexCell cell={cell} column={column} />;
  }

  return <BasicCell cell={cell} column={column} />;
});

Cell.displayName = "Cell";
